import { render, staticRenderFns } from "./importListAction.vue?vue&type=template&id=996cc94c&scoped=true"
import script from "./importListAction.vue?vue&type=script&lang=js"
export * from "./importListAction.vue?vue&type=script&lang=js"
import style0 from "./importListAction.vue?vue&type=style&index=0&id=996cc94c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996cc94c",
  null
  
)

export default component.exports